import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";
import { UserContextConsumer } from "../backend/userContext";

import MainNavbar from "../components/layout/MainNavbar/MainNavbar";
import MainSidebar from "../components/layout/MainSidebar/MainSidebar";
import MainFooter from "../components/layout/MainFooter";
import { Redirect } from "react-router-dom";

const AdminLayout = ({ children, noNavbar, noFooter }) => {
  const [sideBarVisibility, setSideBar] = useState(false);

  const toggleSideBar = () => {
    setSideBar(!sideBarVisibility);
  };

  return (
    <UserContextConsumer>
      {(user) => {
        if (user.user === null || user.user.privileges !== "admin") {
          return <Redirect to={"/not-auth"} />;
        } else
          return (
            <Container fluid>
              <Row>
                <MainSidebar
                  sideBarVisibility={sideBarVisibility}
                  toggleSideBar={toggleSideBar}
                />
                <Col
                  className="main-content p-0"
                  lg={{ size: 10, offset: 2 }}
                  md={{ size: 9, offset: 3 }}
                  sm="12"
                  tag="main"
                >
                  {!noNavbar && <MainNavbar toggleSideBar={toggleSideBar} />}
                  {children}
                  {!noFooter && <MainFooter />}
                </Col>
              </Row>
            </Container>
          );
      }}
    </UserContextConsumer>
  );
};

AdminLayout.propTypes = {
  /**
   * Whether to display the navbar, or not.
   */
  noNavbar: PropTypes.bool,
  /**
   * Whether to display the footer, or not.
   */
  noFooter: PropTypes.bool,
};

AdminLayout.defaultProps = {
  noNavbar: false,
  noFooter: false,
};

export default AdminLayout;
